// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"c95975eb","128":"c95975eb","222":"c95975eb","227":"c95975eb","307":"c95975eb","475":"c95975eb","550":"c95975eb","814":"c95975eb"}[chunkId] + ".chunk.css";
};